(function() {
    const inputSelector = document.querySelector('.header-search-custom #side-panel-search-input');
    const resultsBox = document.querySelector('.header-search-custom .side-panel-content');
    const headerEl = document.querySelector('header');

    inputSelector.addEventListener('input', () => {
        if (inputSelector.value.trim() !== '') {
            resultsBox.classList.add('results-active');
            headerEl.classList.remove('transparent--true');
          } else {
            resultsBox.classList.remove('results-active');
            headerEl.classList.add('transparent--true');
          }
    })
})();